import * as React from 'react';
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { traducirButton } from '../../blocks/traductor';

interface IProps {
    nextStep: () => void
    label?: string
}

const NextButton = ({nextStep, label = traducirButton(15)}: IProps) => {
    return (<>
        <Box display="flex" justifyContent="flex-end" mt={2}>
            <Box>
                <Button variant="contained" color="primary" onClick={() => nextStep()}>
                    {label}
                </Button>
            </Box>
        </Box>
    </>)
};

export default NextButton;
